module.exports = __webpack_public_path__ + "img/tour-40.2b0a17ed.png";